import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { array, object, string } from 'yup';
import { Decision } from '../../../../common/constants/decision';

export interface IneligibleFormData {
  updateReason?: string;
  decision: Decision;
  reason: string;
  mibCodes?: string[];
}

const initialFormData: Partial<IneligibleFormData> = {
  decision: Decision.INELIGIBLE,
  reason: '',
  updateReason: '',
  mibCodes: [],
};

const decisions = Object.values(Decision);

const getSchema = ({ isUpdate }: IneligibleFormOptions) =>
  object().shape({
    updateReason: isUpdate ? string().required('Required field') : string(),
    decision: string<Decision>().oneOf(decisions).required('Required field'),
    reason: string().required('Required field'),
    mibCodes: array(string().required('Invalid code')),
  });

export interface IneligibleFormOptions {
  isUpdate: boolean;
}

const useIneligibleForm = (options: IneligibleFormOptions) => {
  const { control, watch, handleSubmit, reset } = useForm<IneligibleFormData>({
    defaultValues: initialFormData,
    resolver: yupResolver(getSchema(options)),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const clear = useCallback(() => {
    reset(initialFormData);
  }, [reset]);

  return { control, watch, handleSubmit, reset, clear };
};

export default useIneligibleForm;
